import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ListData } from '../../../../models/policy-master.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterService } from '../../../../services/policy-allowance-benefits-service/master.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Editor, Toolbar } from 'ngx-editor';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EnvironmentService } from '../../../../services/environment.service';
import { ToastService } from '../../../../services/toast.service';
import Swal from 'sweetalert2';
import { CompanyService } from '../../../../services/company/company.service';
import { CommonService } from '../../../../services/common/common.service';
import { AuthService } from '../../../../services/auth.service';
import { ExcelService } from '../../../../services/export/excel.service';
import { ValidationService } from '../../../../services/validation/validation.service';
import { FormChangeTrackerService } from '../../../../services/form-change-tracker.service';
import { MenuService } from '../../../../services/menus/menu.service';
import { filter } from 'rxjs';
import { CompanyModel } from '../../../../models/company.model';
@Component({
  selector: 'app-policy-master',
  templateUrl: './master.component.html',
  styleUrl: './master.component.scss'
})
export class MasterComponent implements OnInit {
  @ViewChild('nameInput') nameInput: ElementRef | undefined;
  @ViewChild('titleInput') titleInput: ElementRef | undefined;
  listData: ListData[] = [];
  totalRecords: number = 0;
  currentPage: number = 0;
  myColumns: any = [];
  page = 0;
  menuId: number = 0;
  listView: boolean = true;
  pageSize = this.listView ? 10 : 100;
  currentSortOrder: 'asc' | 'desc' = 'desc';
  currentSortField: any = "createdAt";
  viewType: 'grid' | 'list' = 'list';
  currentFilters: any = null;
  search: string = '';

  pageTitle: string = '';
  date: any = 'dd-mm-yy'
  angularDateFormat: any;
  loading: boolean = true;
  saveClick: boolean = false;
  popupType: any = false;
  form!: FormGroup;
  image: File | null = null;
  imagePreview: string | null = null;
  htmlContent: string = '';

  companyList: CompanyModel[] = [];
  hideCompany: boolean = false;
  formKey: string = 'policyMasterForm';
  isDisable: boolean = false;
  selectedFile: File | null = null;
  textExtractModal: any[] = [];
  dateFormat: any = 'dd/MM/yyyy';
  isFirstLoad = true;

  constructor(
    private readonly router: Router,
    private readonly masterServices: MasterService,
    private readonly modalService: NgbModal,
    private readonly env: EnvironmentService,
    private readonly fb: FormBuilder,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
    private readonly commonService: CommonService,
    private readonly auth: AuthService,
    private readonly excelService: ExcelService,
    private readonly validation: ValidationService,
    private readonly formChangeService: FormChangeTrackerService,
    private route: ActivatedRoute,
    private readonly menuService: MenuService
  ) {
    this.editor = new Editor();
    this.form = this.fb.group({
      company_id: ['', [Validators.required]],
      id: [''],
      title: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(this.validation.letterSpace)]],
      code: ['', [Validators.required]],
      description: ['', [Validators.required]],
      acknowledgement: [false],
      status: [1],
      skip_count: ['', [Validators.min(0), Validators.max(50), Validators.pattern(this.validation.allowNumber)]],
    })
  }

  // ------------model popup--------
  editor: Editor = new Editor();
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  async openGallery(content: any, type: any, data: any) {
    if (type == "View" || type == "Edit") {
      this.router.navigate(['app/master/policy-master/add-policy-master/edit/' + data.uuid]);
      // await this.onCompanyChange(data.company_id);
      // this.form.patchValue({
      //   id: data.id,
      //   title: data.title,
      //   code: data.code,
      //   status: data.status,
      //   acknowledgement: data.acknowledgement,
      //   skip_count: data.skip_count,
      //   description: data.description,
      //   company_id: data.company_id,
      // });
      // this.htmlContent = data.description
      // if (data.image) {
      //   this.imagePreview = data.image
      // } else {
      //   this.imagePreview = ''
      // }
      // this.formChangeService.registerForm(this.formKey, this.form);
      // this.isFormChanged()
      // this.popupType = type
      // if (type == "View") {
      //   this.form.get('description')?.disable();
      //   this.form.get('company_id')?.disable();
      //   this.form.get('title')?.disable();
      //   this.form.get('code')?.disable();
      //   this.form.get('status')?.disable();
      //   this.form.get('acknowledgement')?.disable();
      //   this.form.get('skip_count')?.disable();
      //   // this.form.get('file').disable();
      // } else {
      //   this.form.get('description')?.enable();
      //   this.form.get('company_id')?.enable();
      //   this.form.get('title')?.enable();
      //   this.form.get('code')?.enable();
      //   this.form.get('status')?.enable();
      //   this.form.get('acknowledgement')?.enable();
      //   this.form.get('skip_count')?.enable();
      // }
    } else {
      this.popupType = type;
      // this.saveClick = false;
      this.clearForm();
    }
    // this.modalService.open(content, { size: 'lg' });
    setTimeout(() => {
      if (this.nameInput) {
        this.nameInput.nativeElement.blur();
        const control = this.form.get('company_id');
        if (control) {
          control.markAsPristine();
          control.markAsUntouched();
        }
      }
      if (this.titleInput) {
        this.titleInput.nativeElement.blur();
        const control = this.form.get('title');
        if (control) {
          control.markAsPristine();
          control.markAsUntouched();
        }
      }
    }, 0);
  }

  getShortText(html: string, wordLimit: number = 10): string {
    if (!html) return '';
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const text = temp.textContent || temp.innerText || '';
    const words = text.trim().split(/\s+/);
    return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : text;
  }

  getDateFormat(companyId: any) {
    this.companyService.getParametersById(companyId).subscribe({
      next: (resp) => {
        if (resp?.data?.date_format) {
          this.dateFormat = resp?.data?.date_format.replace('mm', 'MM');
          this.date = resp.data.date_format;
          this.angularDateFormat =
            this.commonService.convertPrimeNGToAngularFormat(this.date);

        }
      },
    });
  }
  onViewChange(type: 'grid' | 'list') {
    this.viewType = type;
  }
  isFormChanged() {
    this.isDisable = this.formChangeService.hasChanged(this.formKey, this.form);
  }
  handleFilterChange(payload: any) {
    const pageNumber = payload?.page ?? 0;
    const itemsPerPage = payload?.pageSize ?? 10;
    const sortField = payload?.orderby ?? 'createdAt';
    const sortOrder = payload?.order ?? 'desc';
    const search = payload?.search ?? '';
    const modelType = this.pageTitle;
    const filters = payload?.filters;

    this.currentPage = pageNumber;
    this.page = pageNumber + 1;
    this.pageSize = itemsPerPage;
    this.currentSortField = sortField;
    this.currentSortOrder = sortOrder;
    this.search = search;
    if (payload && payload.filters !== undefined) {
      this.currentFilters = payload.filters;
    }

    this.getMasterDataList(
      pageNumber,
      itemsPerPage,
      sortField,
      sortOrder,
      modelType,
      search,
      this.currentFilters
    );
  }
  findInvalidControls(): string[] {
    const invalidControls: string[] = [];
    Object.keys(this.form.controls).forEach((controlName) => {
      const control = this.form.get(controlName);
      if (control && control.invalid) {
        invalidControls.push(controlName); // Add invalid control name to the array
      }
    });
    return invalidControls;
  }

  searchTable(event: Event) {
    this.currentPage = 0;
    this.search = (event.target as HTMLInputElement).value;
    this.getMasterDataList(
      this.currentPage,
      this.pageSize,
      this.currentSortField,
      this.currentSortOrder,
      this.pageTitle,
      this.search,
      this.currentFilters || {}
    );
  }

  formSubmit(): void {
    this.saveClick = true;
    if (!this.form.valid) {
      this.updateFormErrors();
      const invalidFields = this.findInvalidControls();
      // console.log("=-=-invalidFields", invalidFields);
      return;
    } else {
      const formData = new FormData();
      formData.append('title', this.form.value.title);
      formData.append('code', this.form.value.code);
      formData.append('status', this.form.value.status);
      formData.append('acknowledgement', this.form.value.acknowledgement);
      formData.append('skip_count', this.form.value.skip_count ?? '');
      formData.append('description', this.form.value.description);
      formData.append('modeltype', this.pageTitle);
      formData.append('file', this.image!);
      formData.append('company_id', this.form.value.company_id);

      const apiCall = this.popupType === "Add"
        ? this.masterServices.createMaster(formData)
        : this.masterServices.updateMaster(formData, this.form.value.id);

      apiCall.subscribe({
        next: (resp) => {
          const action = this.popupType === "Add" ? "created" : "updated";
          this.toastService.success(`${this.pageTitle} ${action} successfully`);
          this.formChangeService.resetForm(this.formKey, this.form);
          this.isDisable = false;
          this.clearForm();
          this.getMasterDataList(
            this.currentPage,
            this.pageSize,
            this.currentSortField,
            this.currentSortOrder,
            this.pageTitle,
            this.search,
            this.currentFilters || {}
          );
          this.modalService.dismissAll();
        },
        error: (err) => {
          console.log(err.error.message);
          this.toastService.failure(err.error.message);
        },
      });
    }

  }

  clearForm() {
    this.modalService.dismissAll();
    let data: any = this.commonService.getLocalStorageData();
    this.form.patchValue({
      id: '',
      title: '',
      code: '',
      status: 1,
      description: '',
      skip_count: '',
      company_id: data.companyID ? data.companyID : '',
    })
    this.formChangeService.resetForm(this.formKey, this.form);
    this.isDisable = false;
    this.htmlContent = ""
    this.image = null;
    this.imagePreview = null;
    this.saveClick = false;

    this.form.get('description')?.enable();
    this.form.get('company_id')?.enable();
    this.form.get('title')?.enable();
    this.form.get('code')?.enable();
    this.form.get('acknowledgement')?.enable();
    this.form.get('skip_count')?.enable();
  }

  onImageChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];

      // Check if file is more than 4MB
      if (file.size > 4 * 1024 * 1024) {
        this.toastService.failure("Please upload an image below 4MB.");
        target.value = ''; // Clear the input
        this.image = null;
        this.imagePreview = null;
        return;
      }

      this.image = file;

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(file);
    } else {
      this.image = null;
      this.imagePreview = null;
    }
  }

  ngOnDestroy() {
    this.editor.destroy();
    this.formChangeService.unregisterForm(this.formKey);
  }
  // ------------model popup--------

  ngOnInit(): void {
    // const menuName = this.route.snapshot.data['breadcrumb'];
    // if (menuName) {
    //   this.getMenuIdByName(menuName);
    // }
    this.menuId = this.auth.selectedMenuID ?? 0;
    const currentRoute = this.router.url.split('/').pop();
    this.setTitle(currentRoute ?? '');
    if (this.pageTitle) {
      this.getMasterDataList(
        this.currentPage,
        this.pageSize,
        this.currentSortField,
        this.currentSortOrder,
        this.pageTitle,
        this.search
      );
    }
    this.getClientCompanylistData();
    let data: any = this.commonService.getLocalStorageData();
    if (data) {
      if (!data.client) {
        this.form.patchValue({
          company_id: data.companyID,
        })
        this.hideCompany = true;
        this.getDateFormat(data.companyID);
      }
    }
    this.form.valueChanges.subscribe(() => {
      this.isDisable = this.formChangeService.hasChanged(this.formKey, this.form);
    });

  }

  setTitle(routeSegment: string): void {
    switch (routeSegment) {
      case 'policy-master':
        this.pageTitle = 'Policy';
        break;
      case 'allowance-master':
        this.pageTitle = 'Allowance';
        break;
      case 'benefits-master':
        this.pageTitle = 'Benefits';
        break;
      default:
        this.pageTitle = '';
        break;
    }
  }
  getMenuIdByName(menuName: string): void {
    this.menuService.getAllMenus().subscribe({
      next: (res: any) => {
        if (res?.data && Array.isArray(res.data)) {
          const menu = res.data.find(
            (m: any) => m.name?.trim().toLowerCase() === menuName.toLowerCase()
          );

          if (menu) {
            this.menuId = menu.id;
            console.log(`📦 Menu ID found for "${menuName}":`, this.menuId);
          } else {
            console.warn(`⚠️ No matching menu found for "${menuName}"`);
            this.menuId = 0;
          }
        } else {
          console.error('❌ Invalid response from getAllMenus()');
        }
      },
      error: (err) => {
        console.error('❌ Failed to load menu list', err);
      },
    });
  }
  getMasterDataList(pagenumber: number, numberofitemsperpage: number, sortfield: any, sortorder: any, modeltype: string, search: any, filters?: any) {
    this.loading = true;
    this.masterServices.getMasterDataList(pagenumber, numberofitemsperpage, sortfield, sortorder, modeltype, search, filters).subscribe({
      next: (response) => {
        if (response?.data?.data?.rows && response?.data?.data?.rows.length > 0) {
          this.listData = response.data.data.rows;
        } else {
          this.listData = []
        }
        this.totalRecords = response?.data?.totalItems;
        this.currentPage = response?.data?.currentPage ?? 0;
        this.page = this.currentPage + 1;
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }


  // -----sorting and pagination--------------
  onLazyLoad(event: any): void {
    console.log("event++++------", event);


    const orderby = event.orderby || this.currentSortField;
    const order = event.order === 1 ? 'desc' : 'asc';

    this.currentSortField = orderby;
    this.currentSortOrder = order;
    this.getMasterDataList(
      this.currentPage,
      this.pageSize,
      this.currentSortField,
      this.currentSortOrder,
      this.pageTitle,
      this.search,
      this.currentFilters || {}
    );
  }

  handlePageChange(newPage: number): void {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      return;
    }
    this.currentPage = newPage - 1
    this.getMasterDataList(
      this.currentPage,
      this.pageSize,
      this.currentSortField,
      this.currentSortOrder,
      this.pageTitle,
      this.search,
      this.currentFilters || {}
    );
  }

  // ------delete--------
  confirmDelete(id: any): void {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.masterServices.deleteMaster(id).subscribe({
          next: (resp) => {
            this.toastService.success(`Deleted successfully`);
            this.clearForm();
            this.getMasterDataList(
              this.currentPage,
              this.pageSize,
              this.currentSortField,
              this.currentSortOrder,
              this.pageTitle,
              this.search,
              this.currentFilters || {}
            );
          },
          error: (err) => {
            this.toastService.failure(err.error.message);
          },
        });
      }
    });
  }

  isInvalid(controlName: any): any {
    const control = this.form.get(controlName);
    return (
      (this.saveClick && control?.invalid) ||
      (this.saveClick && !!control?.errors) ||
      (control?.invalid && (control.dirty || control.touched))
    );
  }

  formErrors: any = {};
  private updateFormErrors(): void {
    this.formErrors = {};
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);

      if (control && control.errors) {
        this.formErrors[field] = control.errors;
      }
    });

  }

  getClientCompanylistData() {
    this.companyService.getClientCompanyList().subscribe({
      next: (resp: any) => {
        this.companyList = resp.data;
      }
    })
  }

  onCompanyChange(event: any) {
    if (typeof (event) == 'number') {
    }
    else {
      let id = event.target.value;
    }
  }

  // getLocationList(id: any): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     this.companyService.getLocationByCompany(id)
  //       .subscribe({
  //         next: (resp) => {
  //           this.locationList = resp.data;
  //           resolve();
  //         },
  //         error: (err) => {
  //           this.locationList = []
  //           reject(err);
  //         }
  //       });
  //   });
  // }

  checkPermission(type: string) {
    return this.auth.checkPermission(type);
  }

  getAllPolicyAllowanceBenefitsForExport(): Promise<any[]> {
    const exportSize = this.totalRecords > 0 ? this.totalRecords : 100000;
    this.loading = true;

    return new Promise((resolve, reject) => {
      this.masterServices.getMasterDataList(0, exportSize, this.currentSortField, this.currentSortOrder, this.pageTitle, '', {}).subscribe({
        next: (response: any) => {
          const rows = response?.data?.data?.rows ?? response?.data ?? [];
          this.loading = false;
          const flatRows = rows.map((item: any) => {
            return {
              ...item,
              company_id: item?.CompanyModel?.company_name ?? item?.company_id ?? '',
              description: item?.description ? this.getShortText(item.description, 20000) : '',
              created_by: item?.createdBy?.username ? `${item.createdBy.username}` : item?.created_by ?? '',
              updated_by: item?.updatedBy?.username ? `${item.updatedBy.username}` : item?.updated_by ?? '',
              status: item?.status === 1 ? 'Active' : item?.status === 0 ? 'Inactive' : item?.status,
            };
          });
          resolve(flatRows);
        },
        error: (err: any) => {
          console.error('Export error', err);
          this.loading = false;
          reject(err);
        }
      });
    });
  }

  isMenuOpen = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  exportTable() {
    this.excelService.exportTableToExcel('menusTable');
  }

  removeImage() {
    this.imagePreview = null;
    this.form.patchValue({
      image: '',
    });
    const fileInput = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }


  //Modal Logic
  open(content: TemplateRef<any>) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result: any) => {
          // this.closeResult.set(Closed with: ${result});
        },
        (reason: any) => {
          // this.closeResult.set(Dismissed ${this.getDismissReason(reason)});
        },
      );
  }





  textcontentEditerValue: any;

  onFileSelected(event: any, modal: any) {
    // console.log(event);
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }

    if (!this.selectedFile) {
      alert('No file selected');
      return;
    }

    this.masterServices.extractTextFromFile(this.selectedFile).subscribe({
      next: (res: any) => {
        // console.log('Upload success', res);
        // console.log('HTML Content:', res.html_content);
        this.htmlContent = res?.html_content;
        modal.dismiss(); // Close modal on success
      },
      error: (err) => {
        console.error('Upload error', err);
        this.toastService.showError('Failed to extract text from file');
        modal.dismiss(); // Also close modal on error
      },
    });
  }





}
